export var DataCatalogTagInheritance;
(function (DataCatalogTagInheritance) {
    DataCatalogTagInheritance["DATA_CATALOG_TAG_INHERITANCE_NONE"] = "NONE";
    DataCatalogTagInheritance["DATA_CATALOG_TAG_INHERITANCE_NEAREST_ANCESTOR"] = "NEAREST_ANCESTOR";
})(DataCatalogTagInheritance || (DataCatalogTagInheritance = {}));
